module.exports = __webpack_public_path__ + "static/media/default-property_new.847a9aba.png";